import { useCallback, useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import PermanentReplacementService from '../../services/PermanentReplacementService';
import CallButton from '../Common/CallButton/CallButton';
import { UserType } from '../../enums/common';

interface InputProps {
    houseId: number;
}

const permanentReplacementService = new PermanentReplacementService();

const COLUMNS: CommonListColumn[] = [
    { label: 'Id', field: 'id' },
    { label: 'Status', field: 'status', type: 'status' },
    { label: 'CX Name', field: 'customerName' },
    {
        label: 'CX Mobile',
        stopRowClick: true,
        render: (row) => <CallButton toPhoneNumber={row?.customerPhone} userType={UserType.CUSTOMER} />,
    },
    { label: 'Owner Id', field: 'ownerId' },
    { label: 'User Bundle Id', field: 'userBundleMappingId' },
    { label: 'Owner Name', field: 'ownerName' },
    { label: 'Owner Email', field: 'ownerEmail' },
    { label: 'Created At', field: 'createdAt', type: 'datetime' },
    { label: 'Updated At', field: 'updatedAt', type: 'datetime' },
    {
        label: 'Actions',
        stopRowClick: true,
        render: (row) => (
            <Link href={`/#/PermanentReplacement/${row.id}/show`}>
                <Button variant="contained" color="primary" size="small">Show</Button>
            </Link>
        ),
    },
];

const PermanentReplacementTab = ({ houseId }: InputProps) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState<any[]>([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const refreshData = useCallback(() => {
        setLoading(true);
        permanentReplacementService
            .getAllPermanentReplacementForHouse(houseId, rowsPerPage, page * rowsPerPage)
            .then((res) => {
                setData(res?.data ?? []);
                setTotal(res?.total ?? 0);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [houseId, page, rowsPerPage]);

    useEffect(() => {
        refreshData();
    }, [refreshData]);

    return (
        <CommonListTable
            columns={COLUMNS}
            data={data}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            emptyText="No Permanent Replacement Found"
        />
    );
};

export default PermanentReplacementTab;
